import { cn } from "@/lib/utils";
import { LucideIcon } from "lucide-react";

interface StatusCardWidgetProps {
  label: string;
  value: number;
  icon: LucideIcon;
  color: string;
  onClick?: () => void;
  isLoading?: boolean;
}

export const StatusCardWidget = ({
  label,
  value,
  icon: Icon,
  color,
  onClick,
  isLoading,
}: StatusCardWidgetProps) => {
  return (
    <button
      onClick={onClick}
      className="relative flex flex-col gap-3 p-4 rounded-xl text-left transition-all duration-300 border border-border/50 bg-card shadow-sm hover:shadow-lg hover:border-border/80 group h-full w-full"
    >
      {/* Shiny Highlight for 3D feel */}
      <div className="absolute inset-x-4 top-0 h-[1px] bg-gradient-to-r from-transparent via-foreground/10 to-transparent opacity-50" />

      <div className="flex items-center justify-between w-full">
        <span className="text-[10px] font-bold uppercase tracking-wider text-muted-foreground/70 group-hover:text-foreground transition-colors">
          {label}
        </span>
        <div
          className={cn(
            "transition-opacity opacity-70 group-hover:opacity-100",
            color
          )}
        >
          <Icon className="h-4 w-4" />
        </div>
      </div>
      <div>
        {isLoading ? (
          <div className="h-8 w-16 bg-muted animate-pulse rounded" />
        ) : (
          <div className="text-2xl font-bold tracking-tight text-foreground">
            {value}
          </div>
        )}
      </div>
    </button>
  );
};
